import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import { Button } from '@bibliocommons/base-buttons';
import { CaretUp, CaretDown, CaretDouble } from '@bibliocommons/base-icons';
import { childrenShape } from '@bibliocommons/bc-prop-types';

import './TableHeading.scss';

function renderSortIcon(sortDirection) {
  if (sortDirection) {
    return sortDirection === 'asc' ? <CaretUp /> : <CaretDown />;
  }
  return <CaretDouble />;
}

export default function TableHeading({ className, colSpan, sortable, handleSort, sortDirection, children }) {
  const sortButtonClassNames = cn('table-heading__sort-button', {
    'table-heading__sort-button--sorted': !!sortDirection
  });

  const heading = sortable ? (
    <Button className={sortButtonClassNames} dataKey="table-heading-sort" handleClick={handleSort}>
      {children}
      {sortable && <span className="table-heading__sort-button__icon">{renderSortIcon(sortDirection)}</span>}
    </Button>
  ) : (
    children
  );

  return (
    <th scope="col" colSpan={colSpan} className={cn('cp-table-heading', className)}>
      {heading}
    </th>
  );
}

TableHeading.propTypes = {
  className: PropTypes.string,
  colSpan: PropTypes.number,
  children: childrenShape,
  sortable: PropTypes.bool,
  sortDirection: PropTypes.oneOf(['asc', 'desc']),
  handleSort: PropTypes.func
};
